import axios from "axios";
import * as XLSX from "xlsx";
import { getToken } from "firebase/app-check";
import { appCheck } from "../services/firebase"; // ou l'endroit où tu exportes `appCheck`

export const THE_API_KEY = "ShOgoAPI";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // remplace par ta vraie base
});

// ************************************************************************
// SECURED "X-Firebase-AppCheck" "x-api-key" 
// ************************************************************************
export const login = async (email, password) => {
  const appCheckToken = await getToken(appCheck, true);
  try {
    // Envoie la requête de connexion à l'API
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/login`,
      {
        email,
        password,
      },
      {
        headers: {
          "x-api-key": THE_API_KEY,
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );

    // Vérifie la réponse et récupère les tokens
    const idToken = response.data.idToken;
    const refreshToken = response.data.refreshToken;

    const payload = JSON.parse(atob(idToken.split(".")[1]));
    const expiresAt = payload.exp * 1000;

    localStorage.setItem("expiresAt", expiresAt.toString());
    localStorage.setItem("idToken", idToken);
    sessionStorage.setItem("refreshToken", refreshToken);
    //console.log("response.data fu:", JSON.stringify(response.data));
    return JSON.stringify(response.data);
  } catch (err) {
    console.error("Erreur lors de la connexion:", err);
  }
};

export const sendConfirmationEmail = async (
  idFirebase,
  firstname,
  lastname,
  email,
  language
) => {
  const appCheckToken = await getToken(appCheck, true);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/email_personal`,
      {
        idFirebase: idFirebase,
        firstname: firstname,
        lastname: lastname,
        email: email,
        language: language,
      },
      {
        headers: {
          "x-api-key": THE_API_KEY,
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi de l'email :", error);
    throw error;
  }
};

// test de la connexion à l'API
// ****************************
export const randomNumber = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/random-number`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "ShOgoAPI",
        },
        //body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.log("Erreur inattendue :", error);
    return { error: error.message || "Erreur inattendue" };
  }
};

// ************************************************************************
// SECURED
// ************************************************************************

// Intercepteur pour ajouter automatiquement le token
api.interceptors.request.use(
  async (config) => {
    const idToken = await getValidIdToken();
    const appCheckToken = await getToken(appCheck, true);

    if (idToken) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${idToken}`;
      config.headers["x-api-key"] = THE_API_KEY;
      config.headers["X-Firebase-AppCheck"] = appCheckToken.token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Get a certain page of limit users (api. JWT Secured)
// ****************************************************

export const userGrid = async (page, limit) => {
  try {
    const response = await api.get(`/admin/table?page=${page}&limit=${limit}`);
    return JSON.stringify(response.data);
  } catch (err) {
    console.error("Erreur de récupération :", err);
  }
};

// Download all the the badges (api. JWT Secured)
// **********************************************
export const generateAllBadges = async () => {
  try {
    const response = await api.get("/handleGeneratePDF", {
      responseType: "blob", //
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "badges.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    console.log("Badges générés avec succès.");
    return response.data;
  } catch (err) {
    console.error("Erreur de récupération :", err);
  }
};

// Download all the the badges (api. JWT Secured)
// **********************************************
export const generateAllBadges4slice = async () => {
  try {
    const response = await api.get("/handleGeneratePDF4slice", {
      responseType: "blob", //
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "badges.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    console.log("Badges générés avec succès.");
    return response.data;
  } catch (err) {
    console.error("Erreur de récupération :", err);
  }
};

// Décoder le JWT token et le rafrâichir si nécessaire
// ***************************************************

// not used
/*export function isTokenValid(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp > now;
  } catch {
    return false;
  }
}*/

export const getValidIdToken = async () => {
  const idToken = localStorage.getItem("idToken");
  const refreshToken = sessionStorage.getItem("refreshToken");
  const expiresAt = parseInt(localStorage.getItem("expiresAt") || "0", 10);

  if (!idToken || !refreshToken) {
    console.warn("⚠️ Tokens manquants dans le stockage");
    return null;
  }

  const now = Date.now();
  const margin = 5 * 60 * 1000; // 5 minutes
  console.log("getValidIdToken");
  if (now > expiresAt - margin) {
    // 🔄 rafraîchir
    console.log("🔄 Token expiré, rafraîchissement en cours...");
    try {
      const appCheckToken = await getToken(appCheck, true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/refreshToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": THE_API_KEY,
          "X-Firebase-AppCheck": appCheckToken.token,
        },
        body: JSON.stringify({ refreshToken }),
      });

      /*const res = await  axios.post(`${process.env.REACT_APP_API_URL}/refreshToken`, {
        refreshToken: refreshToken,
      });*/

      if (!res.ok) throw new Error("Failed to refresh token");

      const data = await res.json();

      // recalcul expiresAt à partir du nouveau token
      const payload = JSON.parse(atob(idToken.split(".")[1]));
      const expiresAt = payload.exp * 1000;

      localStorage.setItem("idToken", data.idToken);
      localStorage.setItem("expiresAt", expiresAt.toString());
      sessionStorage.setItem("refreshToken", data.refreshToken);

      return data.idToken;
    } catch (err) {
      console.error("⛔ Erreur lors du refresh :", err);
      return null;
    }
  }

  return idToken;
};

// CSV & XLSX (secured because calling UserGrid which is secured)
//***************************************************************

/*export const generateCSV = async () => {
  try {
    const page = 1;
    const limit = 1000; 
    const rawData = await userGrid(0, 1000); 

    const parsed = JSON.parse(rawData);

    const data = parsed.users;

    if (!Array.isArray(data) || data.length === 0) {
      console.warn("Aucune donnée trouvée.");
      return;
    }

    // Trouver toutes les clés uniques
    const allKeys = new Set();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => allKeys.add(key));
    });
    //const keysArray = Array.from(allKeys);
    const keysArray = [
      "organization",
      "lastname",
      "firstname",
      "title",
      "bappMember",
      "invitedBy",
      "email",
      "dinnerReservation",
      "vegetarianMeal",
      "telWork",
      "telCell",
      "createdAt",
      "emailSent",
      "workAdr",
      "workUrl",
      "homeAdr",
      "homeTel",
      "note",
      "telHome",
      "language",
      "locked",
      "mailing",
      "rgpd",
      "registrationCode",
      "id",
    ];

    // Générer les lignes CSV
    const rows = [keysArray.join(",")];

    data.forEach((item) => {
      const row = keysArray.map((key) => {
        const value = item[key];
        if (value === undefined || value === null) return "";
        if (typeof value === "object" && "_seconds" in value) {
          const date = new Date(value._seconds * 1000);
          return `"${date.toISOString()}"`;
        }
        const stringValue = value.toString().replace(/"/g, '""');
        return `"${stringValue}"`;
      });
      rows.push(row.join(","));
    });

    const csvContent = "\uFEFF" + rows.join("\n"); // ✅ BOM UTF-8 ajouté
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "users.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Erreur lors de la génération du CSV :", err);
  } 
};*/

export const generateXLSX = async () => {
  try {
    const rawData = await userGrid(0, 1000);
    const parsed = JSON.parse(rawData);
    const data = parsed.users;

    if (!Array.isArray(data) || data.length === 0) {
      console.warn("Aucune donnée trouvée.");
      return;
    }

    // Obtenir toutes les clés
    const allKeys = new Set();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => allKeys.add(key));
    });
    //const keysArray = Array.from(allKeys);
    const keysArray = [
      "organization",
      "lastname",
      "firstname",
      "title",
      "bappMember",
      "invitedBy",
      "email",
      "dinnerReservation",
      "vegetarianMeal",
      "telWork",
      "telCell",
      "createdAt",
      "emailSent",
      "workAdr",
      "workUrl",
      "homeAdr",
      "homeTel",
      "note",
      "telHome",
      "language",
      "locked",
      "mailing",
      "rgpd",
      "registrationCode",
      "id",
    ];

    // Convertir les données en tableau d'objets homogène
    const cleanedData = data.map((item) => {
      const row = {};
      keysArray.forEach((key) => {
        let value = item[key];
        if (value === undefined || value === null) {
          row[key] = "";
        } else if (typeof value === "object" && "_seconds" in value) {
          row[key] = new Date(value._seconds * 1000).toISOString();
        } else {
          row[key] = value;
        }
      });
      return row;
    });

    // Création de la feuille Excel
    const worksheet = XLSX.utils.json_to_sheet(cleanedData, {
      header: keysArray,
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Utilisateurs");

    // Génération du fichier
    const xlsxBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Déclenchement du téléchargement
    const blob = new Blob([xlsxBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "users.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Erreur lors de la génération du XLSX :", err);
  }
};

// ************************************************************************
// NOT USED
// ************************************************************************

// Créer un utilisateur
// ********************
/*export const createUser = async ({ email, password, displayName }) => {
   try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/create-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password, displayName }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur inconnue.");
    }

    console.log("Utilisateur créé avec succès.");
  } catch (error) {
    console.error(
      "Erreur lors de la création de l'utilisateur :",
      error.message
    );
    throw new Error(error.message || "Impossible de créer l'utilisateur.");
  }
  
};*/
